import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  private static readonly PRODUCTS_KEY = 'Products';
  private readonly storage: StorageService = inject(LOCAL_STORAGE);

  public get(): string[] {
    return this.storage.get(ProductsService.PRODUCTS_KEY);
  }

  public set(products: string[]) {
    this.storage.set(
      ProductsService.PRODUCTS_KEY,
      products.map((s) => s.toLowerCase()),
    );
  }

  public remove() {
    this.storage.remove(ProductsService.PRODUCTS_KEY);
  }
}
